let url;

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  url = 'http://127.0.0.1:8300/api';
} else {
  // url = 'https://sso.kelola.biz/api';
  url = 'https://api-dpmsso.kelola.dev/api';
}

// const urlAssets = 'http://127.0.0.1:8300/storage/';
const urlAssets = 'https://api-dpmsso.kelola.dev/storage';

export { url, urlAssets };
